import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack } from "@mui/material";
import classNames from 'classnames';
import React, { memo, useCallback, useContext, useRef } from "react";
import { DashboardsTableContext } from '../../../../../contexts/TablesContext/DashboardsTableProvider';
import useStyles from "../styles";

const ConnectedAppsColumn: React.FC<{}> = () => {
    const classes = useStyles();
    const { setModalContext } = useContext(DashboardsTableContext);
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleClick = useCallback(() => {
        setModalContext({
            open: 'ConnectedAppsHeaderModal',
            field: 'Connected Apps',
            anchorElement: anchorRef.current,
            onClose: () => setModalContext({}),
        });
    }, [setModalContext]);

    return (
        <Stack direction="row" className={classNames(classes.header, classes.hoverHeader)}
            spacing={1} alignItems="center" justifyContent="flex-start" width="100%" ref={anchorRef}
            onClick={handleClick}>
            <span>{'Connected Apps'}</span>
            <ExpandMoreIcon sx={{ color: '#878E95', '&:hover': { color: '#222529' } }} />
        </Stack>
    );
}

export default memo(ConnectedAppsColumn);
